module.exports = __webpack_public_path__ + "img/download_web.75d63a41.png";